export const SUPPLIER_KEY = 'SUPPLIER' // 供应商表
export const CHANNEL_KEY = 'CHANNEL' // 分销商表
export const USER_KEY = 'USER' // 用户表
export const SUPPLIER_OFFLINE_KEY = 'SUPPLIER_OFFLINE' // 线下供应商表
export const ADDRESS_KEY = 'ADDRESS' // 收货地址表
export const COMPANY_ACTIVITY_APPLY = 'COMPANY_ACTIVITY_APPLY' // 首届聚货会
export const SHOP_REFUND_ORDER = 'SHOP_REFUND_ORDER' // 店铺退款单表
export const DOCKING_PEOPLE = 'DOCKING_PEOPLE' // 管理侧对接人员

// 注意* 查询真实手机号时， id字段在列表中的值：我的分销商页面为channelId, 渠道侧我的供应商页面为supplierId,其他页面为列表id")
